<ng-container *ngIf="contactInfos && canOpenProfileDialog">
  <ng-container *ngFor="let contactInfo of contactInfos">
    <div class="crm-icon-and-organization-name">
      <img [src]="'assets/img/' + contactInfo.organizationType + '-logo.png'" alt="logo" data-testid="logo-crm" />
      <span data-testid="org-name">{{ contactInfo.organizationName }}</span>
    </div>
    <!-- contact linked -->
    <ng-container *ngIf="contactInfo.hasContact; else noContact">
      <ng-container *ngFor="let field of contactInfo.fields; index as index">
        <ng-container *ngIf="field.type !== 'id' && !!field.value">
          <div class="crm-field" [attr.data-testid]="'crm-field-' + index">
            <div class="crm-field-label">{{ field.label }}</div>
            <ng-container [ngSwitch]="field.type">
              <div *ngSwitchCase="'address'">
                {{ field.value.street }} {{ field.value.postalCode }} {{ field.value.city }}
                {{ field.value.country }}
              </div>
              <div *ngSwitchCase="'date'">
                <!-- date without time, entered by user, do not use pipe dateTimezone -->
                {{ field.value | date: 'shortDate' }}
              </div>
              <div *ngSwitchCase="'datetime'">
                {{ field.value | dateTimezone: 'short' }}
              </div>
              <div *ngSwitchDefault>{{ field.value }}</div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!isUserReadOnly">
        <div *ngIf="!isInProfilDialog; else profilDialogButtonsContact" class="crm-buttons">
          <ion-button
            (click)="openProfileDialog(contactInfo.organizationId)"
            fill="clear"
            data-testid="button-see-activity">
            <span translate="m/task-process/profile/crm/see-activity"></span>
          </ion-button>
          <ion-button [href]="contactInfo.url" target="_blank" fill="clear" data-testid="button-see-in-crm">
            <span
              translate="m/task-process/profile/crm/see-in-crm"
              [translateParams]="{ crmName: contactInfo.organizationDisplayType }"></span>
          </ion-button>
        </div>
        <ng-template #profilDialogButtonsContact>
          <div class="crm-buttons">
            <ion-button (click)="goToTab(contactInfo.organizationId)" fill="clear" data-testid="button-more-details">
              <span translate="crm/user-profile/more-details"></span>
            </ion-button>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
    <!-- contact not linked -->
    <ng-template #noContact>
      <div>
        <span
          translate="m/task-process/profile/crm/no-contact-in-crm"
          [translateParams]="{ crmName: contactInfo.organizationDisplayType }"
          data-testid="no-contact-text"></span>
      </div>
      <ng-container *ngIf="!isUserReadOnly">
        <div *ngIf="!isInProfilDialog; else profilDialogButtonsNoContact" class="crm-buttons">
          <ion-button
            (click)="openProfileDialog(contactInfo.organizationId)"
            fill="clear"
            data-testid="button-open-dialog">
            <span
              translate="m/task-process/profile/crm/search-in-crm"
              [translateParams]="{ crmName: contactInfo.organizationDisplayType }"></span>
          </ion-button>
        </div>
        <ng-template #profilDialogButtonsNoContact>
          <div *ngIf="isInProfilDialog" class="crm-buttons">
            <ion-button (click)="goToTab(contactInfo.organizationId)" fill="clear" data-testid="button-search-in">
              <span [translate]="'crm/user-profile/search-in-' + contactInfo.organizationType"></span>
            </ion-button>
          </div>
        </ng-template>
      </ng-container>
    </ng-template>
  </ng-container>
</ng-container>
